import {
  Identification,
} from '../models/index';

const identification: Record<string, Identification> = {
  bookingReferenceIdentification: {
    identificationType: 0,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  },
  eticketNumberIdentification: {
    identificationType: 2,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  },
  ffSVIdentificationAlshehri: {
    identificationType: 3,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '12064986',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  },
  ffSVIdentificationAlthunayan: {
    identificationType: 3,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '15577446',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  },
  ffSVIdentificationAbuhamder: {
    identificationType: 3,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '19470315',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  },
  bpDeeplink: {
    identificationType: 4,
    recloc: '',
    eTicket: '',
    frequentFlyerProgram: 0,
    frequentFlyerNumber: '19470315',
    journeyElementId: '',
    journeyId: '',
    travelerId: ''
  }
};

export const bookingReferenceIdentification = identification.bookingReferenceIdentification;
export const eticketNumberIdentification = identification.eticketNumberIdentification;
export const ffSVIdentificationAlshehri = identification.ffSVIdentificationAlshehri;
export const ffSVIdentificationAlthunayan = identification.ffSVIdentificationAlthunayan;
export const ffSVIdentificationAbuhamder = identification.ffSVIdentificationAbuhamder;
export const bpDeeplink = identification.bpDeeplink;
